import React from 'react'
import Helmet from 'react-helmet'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import PageHeader from '../components/PageHeader'
import BackHome from '../components/BackHome'
import { useFirebase } from "gatsby-plugin-firebase"


const Warunki = () => {

  useFirebase(firebase => {
    firebase
      .analytics()
      .logEvent("visited_warunki")
  }, [])

  return (
  <Layout>
    <Helmet>
      <title>Warunki uczestnictwa - Uczelnie Szkołom – o finansach z NBP</title>
      <meta name="description" content="Warunki uczestnictwa" />
    </Helmet>

    <PageHeader headerText="Warunki uczestnictwa" />

    <div id="main">
      <section id="one">
        <div className="inner">
          <ul>
            <li>
              zajęcia będą odbywać się w Podhalańskiej Państwowej Uczelni
              Zawodowej w Nowym Targu
            </li>
            <li>
              uczniów, pod opieką nauczycieli, zapraszamy na jednodniowe,
              całodzienne (od 9:00 do 15:00) zajęcia, w wybraną przez Państwa
              środę 1, 8, 22, 29. kwietnia lub 13. maja br.
            </li>
            <li>
              oprócz ciekawych zajęć gwarantujemy transport autokarowy uczniów,
              ubezpieczenie, obiad i herbatkę, certyfikat uczestnictwa
            </li>
            <li>liczebność grup to 35 osób</li>
            <li>
              <strong>
                zgłoszenie chęci wzięcia udziału w projekcie odbywa się za
                pośrednictwem{' '}
                <Link to="/rejestracja">tej strony internetowej</Link> projektu
              </strong>
            </li>
            <li>
              szkoła, każdorazowo wypełniając formularz, może zgłosić jedną grupę (klasę lub
              zainteresowanych uczniów z kilku klas), ale do rekrutacji może
              przystąpić wielokrotnie (przykładowo: dyrekcja szkoły, chcąc
              zgłosić trzy grupy, powinna wypełnić formularz trzykrotnie,
              podając każdorazowo inną grupę, której dotyczy zgłoszenie)
            </li>
            <li>
              <strong>kryterium kwalifikacji to kolejność zgłoszeń</strong>; w przypadku
              rezygnacji zakwalifikowanej grupy, do projektu zostanie zaproszona
              kolejna z listy zgłoszonych.{' '}
            </li>
            <li>
              <strong>
                formularz zgłoszenia zostanie uruchomiony w dniu 10 lutego,
                możliwość zgłaszania grup – do 16 lutego 2020 roku
              </strong>
            </li>
            <li>
              listę zakwalifikowanych szkół i grup opublikujemy na stronie
              internetowej 17 lutego 2020 roku
            </li>
            <li>
              skompletowanie dokumentacji niezbędnej do przetwarzania danych
              osobowych uczestników projektów planujemy do 29 lutego br.
            </li>
          </ul>
        </div>
      </section>

      <BackHome />
    </div>
  </Layout>
  )
}

export default Warunki
